import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import BookUs from './components/BookUs';
import Hero from './sections/Hero';
import Insights from './sections/Insights';
import Gallery from './sections/Gallery';
import Services from './sections/Services';
import Portfolio from './sections/Portfolio';
import './index.css';

function App() {
  return (
    <div className="app-main">
      <Header />
      <main>
        <Hero />
        <Testimonials />
        <Insights />
        <Gallery />
        <Services />
        <Portfolio />
      </main>
      <BookUs />
      <Footer />
    </div>
  );
}

export default App;
